export const LOCKED_EVENT_SENT_FIELD = 'lockedEventSent';

/**
 * Cell text for the Locked Event Sent column. Absent means the value was not
 * returned (the lookup failed), shown as a dash rather than a blank cell.
 */
export const lockedEventSentLabel = (value?: boolean | null) => {
  if (value === true) return 'Yes';
  if (value === false) return 'No';
  return '—';
};
